// import React from "react";
// import {
//   Container,
//   Row,
//   Col,
//   Form,
//   Button,
  
// } from "react-bootstrap";   


// export default function RODTEP() {
// //    const [open, setOpen] = useState(0);
  

//   return (
//     <>
//     <div className="bg-light py-5">
    
//            <section className="bg-light">
//                   <Container>
//                     <Row className="g-4 align-items-start">
//                       {/* LEFT CONTENT */}
//                       <Col lg={8}>
//                         <div>

//                   <h1>Deemed Exports and its benefits</h1>
            
//                     <h2>What is RODTEP Scheme</h2>
//                     <p>RoDTEP stands for Remission of Duties and Taxes on Export Products. It is a new scheme this is applicable with impact from January 1st, 2021, formed to replace the existing MEIS (Merchandise Exports from India Scheme). The scheme will make sure that the exporters get hold of the refunds at the embedded taxes and responsibilities formerly non-recoverable. The scheme turned into introduced approximately a good way to increase exports which have been extraordinarily terrible in quantity formerly. The RoDTEP rates would be notified shortly by the Department of Commerce.</p>
                                  
//                     <h2>Need for the RoDTEP Scheme</h2>  
//                                   <p>The US had challenged India’s key export subsidy schemes in the WTO (World Trade Organisation), claiming them to damage the American workers. A dispute panel in the WTO dominated towards India, stating that the export subsidy programmes that have been furnished by the Government of India violated the provisions of the trade body’s norms.</p>
                                  
//                     </div>
//                  </Col>
//                                 <Col lg={4}>
//                                              <div className="p-4 shadow rounded right-form">
//                                                <Form>
//                                                  <Form.Control className="mb-3" placeholder="Name" />
//                                                  <Form.Control className="mb-3" placeholder="Email" />
//                                                  <Form.Control className="mb-3" placeholder="Phone" />
//                                                  <Form.Control className="mb-3" placeholder="Subject" />
//                                                  <Button className="w-100">Get Started</Button>
//                                                </Form>
//                                              </div>
//                                </Col>
//             </Row>                      
//                       <Row className="g-4 align-items-start">
//                           <Col lg={12} xl={12}>
//                               <div>
//                                   <p>The panel similarly endorsed that the export subsidy programmes be withdrawn. This caused the start of the RoDTEP Scheme, if you want to make sure that India remains WTO-compliant.</p>
//                                   <p>The following have been a number of the export subsidy programmes endorsed to be withdrawn: -</p>
                                  
//                                   <ul>
//                                       <li>Merchandise Exports from India Scheme</li>
//                                       <li>Export Oriented Units Scheme</li>
//                                       <li>Electronics Hardware Technology Parks Scheme</li>
//                                       <li>Bio-Technology Parks Scheme</li>
//                                       <li>Export Promotion Capital Goods Scheme</li>
//                                       <li>Special Economic Zones (SEZ) Scheme</li>
//                                       <li>Duty-Free Imports for Exporters Scheme</li>
//                                   </ul>

//                                   <h2>Eligibility to reap benefits of the RoDTEP Scheme</h2>
//                                   <ul>
//                                       <li>All sectors, such as the textiles sector, might also additionally experience the benefits of the RoDTEP Scheme. Labor-in depth sectors that revel in blessings below the MEIS Scheme might be given a priority.</li>
//                                       <li>Manufacturer and merchant exporters are each eligible for the benefits of this scheme.</li>
//                                       <li>There is no unique turnover threshold to assert the RoDTEP.</li>
//                                       <li>Re-exported products aren't eligible under this scheme.</li>
//                                       <li>To be eligible to avail the benefits of this scheme, the exported merchandise want to have the country of origin as India.</li>
//                                       <li>Special Economic Zone Units and Export Oriented Units also are eligible to say the benefits below this scheme.</li>
//                                       <li>Where items were exported through courier via e-trade platforms, RoDTEP scheme applies to them as well.</li>
//                                   </ul>

//                                   <h2>Availing benefits below RoDTEP Scheme</h2>
//                                   <p>The ICEGATE portal (Indian Customs Electronic Gateway) will comprise the details concerning the credit availed by the exporter. At the port, the exporter must suggest in the delivery invoice the details concerning the declare of the RoDTEP benefit with reference to a specific item of export and generate a credit score scrip for it. These credit score scrips are then used to pay simple customs responsibilities, declare rebates or may be transferred to different importers, because the case may be.</p>

//                                   <p>The procedure for the era and claiming of scrips below the RoDTEP scheme are as follows-</p>

//                                   <ul>
//                                       <li>The exporter has to make a declaration of the claim for RoDTEP in the delivery invoice.</li>
//                                       <li>Once the Export General Manifest (EGM) is filed, the declare might be processed by the Customs.</li>
//                                       <li>After processing the claim, a scroll with all individual Shipping Bills for the admissible quantity might be generated and to be had in the customer’s account at ICEGATE portal.</li>
//                                       <li>The exporter has to log in to the ICEGATE portal and create a RoDTEP credit ledger account</li>
//                                       <li>After the RoDTEP credit ledger account is created, the exporters can log in to their bills and generate scrips by choosing the relevant delivery bills.</li>
//                                       <li>Once, the scrips are generated, the refund might be credited and pondered in the exporter’s ledger account and might be available for utilization in fee of the eligible responsibilities and during imports or for transfer to another importers.</li>
//                                   </ul>
//                                   <p>Currently, the charge of responsibility of remission for the goods under RoDTEP scheme isn't yet notified by the Government of India.</p>

//                                   <h2>At Apex Services What We Do</h2>
//                                   <p>Our highly qualified team is constantly updating themselves with the Foreign Trade Policies so that we can give a wholesome advice to our clients regarding their concerns and guide them from document preparation to obtaining the Licence in hand. Our Team will Guide you through the Process of RoDTEP Scheme.</p>
                              
//                               </div> 
//                               </Col>
//                           </Row>
//             </Container>
//         </section>
        
//     </div>
//     </>    
//   );
// }


import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaCheckCircle,
  FaFileAlt,
  FaGlobe,
  FaList,
  FaRocket,
  FaIndustry,
  FaExclamationTriangle,
  FaHandsHelping
} from "react-icons/fa";

export default function RODTEP() {
  return (
    <div className="bg-light py-5">
      <section className="bg-light">
        <Container>

          {/* TOP */}
          <Row className="g-4 align-items-start mb-4">

            <Col lg={8}>
              <h1>
                RoDTEP Scheme (Remission of Duties & Taxes on Export Products)
              </h1>

              <p>
                RoDTEP is a Government of India scheme that refunds hidden taxes
                and duties not covered under any other export incentive scheme.
              </p>

              <p>
                It helps exporters improve competitiveness by reducing costs and
                ensuring WTO-compliant benefits.
              </p>
            </Col>

            <Col lg={4}>
              {/* Add your right-side form */}
            </Col>

          </Row>

          {/* WHAT IS */}
          <h2 className="section-title">
            <FaFileAlt className="icon" /> What is RoDTEP Scheme?
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Refunds hidden taxes like electricity duty, VAT, mandi tax</li>
            <li><FaCheckCircle /> Applicable from 1st January 2021</li>
            <li><FaCheckCircle /> Benefits provided as transferable duty credit</li>
            <li><FaCheckCircle /> Replaced earlier schemes like MEIS</li>
          </ul>

          {/* WHY */}
          <h2 className="section-title">
            <FaGlobe className="icon" /> Why RoDTEP Was Introduced
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Ensure WTO compliance</li>
            <li><FaCheckCircle /> Replace non-compliant schemes</li>
            <li><FaCheckCircle /> Boost export competitiveness</li>
            <li><FaCheckCircle /> Refund unrecoverable taxes</li>
          </ul>

          {/* ELIGIBILITY */}
          <h2 className="section-title">
            <FaList className="icon" /> Eligibility
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Manufacturer exporters</li>
            <li><FaCheckCircle /> Merchant exporters</li>
            <li><FaCheckCircle /> MSMEs and large exporters</li>
            <li><FaCheckCircle /> E-commerce exporters</li>
            <li><FaCheckCircle /> Goods must originate from India</li>
          </ul>

          {/* FEATURES */}
          <h2 className="section-title">
            <FaRocket className="icon" /> Key Features
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> No minimum turnover requirement</li>
            <li><FaCheckCircle /> HS Code based benefit rates</li>
            <li><FaCheckCircle /> Fully digital processing via ICEGATE</li>
            <li><FaCheckCircle /> Transferable credits</li>
          </ul>

          {/* PROCESS */}
          <h2 className="section-title">
            <FaIndustry className="icon" /> How You Get Benefits
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Declare RoDTEP in shipping bill</li>
            <li><FaCheckCircle /> EGM filing by carrier</li>
            <li><FaCheckCircle /> Customs processing</li>
            <li><FaCheckCircle /> Credit appears in ICEGATE ledger</li>
            <li><FaCheckCircle /> Use or transfer credits</li>
          </ul>

          {/* DOCUMENTS */}
          <h2 className="section-title">
            <FaFileAlt className="icon" /> Documents Required
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> IEC Code</li>
            <li><FaCheckCircle /> Shipping bills</li>
            <li><FaCheckCircle /> Invoice & packing list</li>
            <li><FaCheckCircle /> BRC (Bank realization)</li>
            <li><FaCheckCircle /> GST details</li>
          </ul>

          {/* MISTAKES */}
          <h2 className="section-title">
            <FaExclamationTriangle className="icon" /> Common Mistakes
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Missing declaration in shipping bill</li>
            <li><FaCheckCircle /> Incorrect HS code</li>
            <li><FaCheckCircle /> Delay in EGM filing</li>
            <li><FaCheckCircle /> Incomplete documentation</li>
          </ul>

          {/* NOTES */}
          <h2 className="section-title">
            <FaGlobe className="icon" /> Important Notes
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Benefits vary by product category</li>
            <li><FaCheckCircle /> Rates notified by government</li>
            <li><FaCheckCircle /> Credits maintained in ICEGATE</li>
            <li><FaCheckCircle /> Fully online process</li>
          </ul>

          {/* HELP */}
          <h2 className="section-title">
            <FaHandsHelping className="icon" /> How We Help You
          </h2>

          <p>
            At Apex Consultants, we provide complete support including claim setup,
            shipping bill correction, error handling, and maximizing benefits
            under the RoDTEP scheme.
          </p>

        </Container>
      </section>
    </div>
  );
}